export enum LoginType {
  Account = 'account',
  MagicLink = 'magic-link',
  PhoneNumber = 'phone-number',
}
